export const SPHERE_CONVERSION_FEE_BPS = 10;
export const SPHERE_FEE_ENABLED = false;
